<template>
    <v-container fluid class="container-full-bg-gray">
        <v-snackbar
            v-model="screen_data.snackbar.isVisible"
            :color="screen_data.snackbar.color"
            :timeout="screen_data.snackbar.timeout"
            >
            {{ screen_data.snackbar.text }}
        </v-snackbar>

        <app-row>
            <app-col cols="12">
                <v-card width="100%" class="rounded-lg">
                    <v-card-title class="d-flex">
                        <div class="mr-auto d-flex align-sm-center">
                            <v-btn v-if="companydb_id" icon
                                @click="$router.push({ name: 'entities-list', params: { 'companydb_id': companydb_id } })">
                                <AppIcon :src="require('../assets/back-arrow.svg')" :size="20" :preserveColors="true"/>
                            </v-btn>
                            <h4 class="primary_blue--text ml-2">Editor de tipos</h4>
                        </div>
                        <v-spacer></v-spacer>
                        <div>
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                    class="ml-1 mr-2"
                                    icon
                                        v-bind="attrs"
                                        v-on="on"
                                        @click="save()"
                                        :loading="screen_data.loading">
                                        <AppIcon :src="require('../assets/save_invoice.svg')" :size="29" :color-map="{ '060647': 'primary_blue' }" />
                                    </v-btn>
                                </template>
                                <span>Guardar tipo</span>
                            </v-tooltip>
                        </div>

                    </v-card-title>
                    <v-divider></v-divider>

                    <v-tabs v-model="currentTab">
                        <v-tab key="datos">Datos</v-tab>
                        <v-tab key="vistas">Vistas</v-tab>
                        <v-tab key="traducciones">
                            Traducciones
                            <v-chip v-if="hasTranslations" x-small color="success" class="ml-1">i18n</v-chip>
                        </v-tab>
                        <v-tab key="acciones">Acciones</v-tab>
                        <v-tab key="crud_config">CRUD Config</v-tab>
                    </v-tabs>

                    <v-tabs-items v-model="currentTab">
                        <!-- Tab: Datos -->
                        <v-tab-item key="datos">
                            <!-- SECCIÓN: Información básica -->
                    <v-card-text v-if="screen_data.entityType" class="section-container">
                        <app-row>
                            <app-col cols="12">
                                <h3 class="section-title mb-4">
                                    <v-icon left color="primary">mdi-information</v-icon>
                                    Información básica
                                </h3>
                            </app-col>
                        </app-row>
                        <app-row>
                            <app-col cols="6">
                                <v-text-field
                                    label="Nombre del tipo"
                                    outlined
                                    dense
                                    v-model="screen_data.entityType.name"
                                    prepend-inner-icon="mdi-tag"
                                    placeholder="Ej: Factura, Cliente, Producto..."
                                >
                                </v-text-field>
                            </app-col>
                            <app-col cols="6">
                                <v-select
                                    outlined
                                    dense
                                    label="Tipo de entidad"
                                    item-text="name"
                                    item-value="value"
                                    :items="[{'name':'Registro', 'value':null}, {'name':'Interfaz', 'value':'ui'}, {'name':'Parámetros Workflow', 'value':'params'}]"
                                    v-model="screen_data.entityType.kind"
                                    prepend-inner-icon="mdi-shape"
                                    hint="⚠️ Este campo no se usa actualmente - puede dejarse vacío"
                                    persistent-hint
                                    disabled
                                >
                                </v-select>
                            </app-col>
                        </app-row>
                        <app-row v-if="im_staff_or_loginas">
                            <app-col cols="12">
                                <div class="advanced-options">
                                    <div class="advanced-options-title mb-2">
                                        <v-icon small color="grey darken-1">mdi-cog</v-icon>
                                        <span class="ml-1">Visibilidad y protect</span>
                                    </div>
                                    <v-row>
                                        <v-col cols="6">
                                            <v-switch
                                                label="Visible"
                                                v-model="screen_data.entityType.is_visible"
                                                color="primary"
                                                hide-details
                                                inset
                                            >
                                                <template v-slot:label>
                                                    <span>
                                                        <v-icon small left>mdi-eye</v-icon>
                                                        Visible
                                                    </span>
                                                </template>
                                            </v-switch>
                                        </v-col>
                                        <v-col cols="6">
                                            <v-switch
                                                label="Protegido"
                                                v-model="screen_data.entityType.is_protected"
                                                color="primary"
                                                hide-details
                                                inset
                                            >
                                                <template v-slot:label>
                                                    <span>
                                                        <v-icon small left>mdi-lock</v-icon>
                                                        Protegido
                                                    </span>
                                                </template>
                                            </v-switch>
                                        </v-col>
                                    </v-row>
                                </div>
                            </app-col>
                        </app-row>
                    </v-card-text>

                    <!-- SECCIÓN: Schema -->
                    <v-divider></v-divider>
                    <v-card-text v-if="screen_data.entityType" class="section-container">
                        <app-row>
                            <app-col cols="12" class="d-flex align-center justify-space-between">
                                <h3 class="section-title mb-0">
                                    <v-icon left color="primary">mdi-file-tree</v-icon>
                                    Esquema de datos
                                </h3>
                                <v-btn-toggle v-model="schemaEditMode" mandatory dense class="schema-mode-toggle" @change="onSchemaEditModeChange">
                                    <v-btn small value="visual">
                                        <v-icon small left>mdi-form-select</v-icon>
                                        Visual
                                    </v-btn>
                                    <v-btn small value="json">
                                        <v-icon small left>mdi-code-json</v-icon>
                                        JSON
                                    </v-btn>
                                </v-btn-toggle>
                            </app-col>
                        </app-row>

                        <!-- Visual Editor Mode -->
                        <app-row v-if="schemaEditMode === 'visual'">
                            <app-col cols="12">
                                <div class="own_component">
                                    <EntitySchemaEditorComponent
                                        v-model="screen_data.entityType.schema"
                                        :intern_key="screen_data.entityType.name"
                                        :extra_types="screen_data.available_extra_types"
                                    />
                                </div>
                            </app-col>
                        </app-row>

                        <!-- JSON Editor Mode -->
                        <app-row v-if="schemaEditMode === 'json'">
                            <app-col cols="12">
                                <div class="json-editor-container mt-4">
                                    <div class="json-editor-toolbar d-flex align-center mb-2">
                                        <v-btn small text color="primary" @click="formatJson" class="mr-2">
                                            <v-icon small left>mdi-auto-fix</v-icon>
                                            Formatear
                                        </v-btn>
                                        <v-btn small text color="primary" @click="copyJson" class="mr-2">
                                            <v-icon small left>mdi-content-copy</v-icon>
                                            Copiar
                                        </v-btn>
                                        <v-btn small text color="primary" @click="pasteJson" class="mr-2">
                                            <v-icon small left>mdi-content-paste</v-icon>
                                            Pegar
                                        </v-btn>
                                        <v-spacer></v-spacer>
                                        <v-chip v-if="jsonError" small color="error" text-color="white">
                                            <v-icon small left>mdi-alert-circle</v-icon>
                                            JSON inválido
                                        </v-chip>
                                        <v-chip v-else small color="success" text-color="white">
                                            <v-icon small left>mdi-check-circle</v-icon>
                                            JSON válido
                                        </v-chip>
                                    </div>
                                    <v-textarea
                                        v-model="schemaJsonText"
                                        outlined
                                        dense
                                        rows="20"
                                        class="json-textarea"
                                        :error="!!jsonError"
                                        :error-messages="jsonError"
                                        placeholder="Pega aquí tu JSON Schema..."
                                        @input="onJsonInput"
                                        spellcheck="false"
                                    ></v-textarea>
                                </div>
                            </app-col>
                        </app-row>
                    </v-card-text>

                        </v-tab-item>

                        <!-- Tab: Vistas -->
                        <v-tab-item key="vistas">
                            <v-tabs v-model="vistasTab" class="vistas-inner-tabs">
                                <v-tab>
                                    <v-icon left small>mdi-view-dashboard-variant</v-icon>
                                    Editor/Viewer
                                </v-tab>
                                <v-tab>
                                    <v-icon left small>mdi-plus-circle-outline</v-icon>
                                    Creación
                                </v-tab>
                                <v-tab>
                                    <v-icon left small>mdi-view-list</v-icon>
                                    Listado principal
                                </v-tab>
                                <v-tab>
                                    <v-icon left small>mdi-table-edit</v-icon>
                                    Listado editable
                                </v-tab>
                                <v-tab>
                                    <v-icon left small>mdi-card-account-details</v-icon>
                                    Singleton
                                </v-tab>
                            </v-tabs>

                            <!-- Solo renderiza el tab activo -->
                            <v-card-text v-if="vistasTab === 0 && screen_data.entityType && screen_data.entityType.ui_config" class="section-container">
                                <VibeComponentGenerator
                                    key="vibe-editor"
                                    title="Default Editor/Viewer"
                                    icon="mdi-view-dashboard-variant"
                                    :basePrompt="editorBasePrompt"
                                    v-model="screen_data.entityType.ui_config.editor_template"
                                    :options.sync="screen_data.entityType.ui_config.editor_options"
                                    :previewSchema="screen_data.entityType.schema"
                                    :actionsCatalog="screen_data.entityType.actions_catalog"
                                    :companyId="null"
                                />
                            </v-card-text>

                            <v-card-text v-if="vistasTab === 1 && screen_data.entityType && screen_data.entityType.ui_config" class="section-container">
                                <VibeComponentGenerator
                                    key="vibe-create"
                                    title="Formulario de Creación"
                                    icon="mdi-plus-circle-outline"
                                    :basePrompt="createBasePrompt"
                                    v-model="screen_data.entityType.ui_config.create_template"
                                    :options.sync="screen_data.entityType.ui_config.create_options"
                                    :previewSchema="screen_data.entityType.schema"
                                    :actionsCatalog="screen_data.entityType.actions_catalog"
                                    :companyId="null"
                                />
                                <v-alert type="info" text dense class="mt-4">
                                    <strong>Nota:</strong> Si no se define un template de creación, se usará el Editor/Viewer por defecto.
                                </v-alert>

                                <v-divider class="my-6"></v-divider>

                                <app-row>
                                    <app-col cols="12">
                                        <h3 class="section-title mb-4">
                                            <v-icon left color="primary">mdi-database-plus</v-icon>
                                            Payload por defecto al crear
                                        </h3>
                                        <v-alert type="info" text dense class="mb-4">
                                            Define valores iniciales para el formulario de creación. Si no se define, se usará un objeto vacío.
                                        </v-alert>
                                    </app-col>
                                </app-row>
                                <app-row>
                                    <app-col cols="12">
                                        <div class="json-editor-container">
                                            <div class="json-editor-toolbar d-flex align-center mb-2">
                                                <v-btn small text color="success" @click="generateDefaultPayloadTemplate" class="mr-2">
                                                    <v-icon small left>mdi-file-document-plus</v-icon>
                                                    Generar plantilla
                                                </v-btn>
                                                <v-btn small text color="primary" @click="formatDefaultPayloadJson" class="mr-2">
                                                    <v-icon small left>mdi-auto-fix</v-icon>
                                                    Formatear
                                                </v-btn>
                                                <v-btn small text color="error" @click="clearDefaultPayload" class="mr-2">
                                                    <v-icon small left>mdi-delete</v-icon>
                                                    Limpiar
                                                </v-btn>
                                                <v-spacer></v-spacer>
                                                <v-chip v-if="defaultPayloadJsonError" small color="error" text-color="white">
                                                    <v-icon small left>mdi-alert-circle</v-icon>
                                                    JSON inválido
                                                </v-chip>
                                                <v-chip v-else-if="defaultPayloadJsonText" small color="success" text-color="white">
                                                    <v-icon small left>mdi-check-circle</v-icon>
                                                    JSON válido
                                                </v-chip>
                                            </div>
                                            <v-textarea
                                                v-model="defaultPayloadJsonText"
                                                outlined
                                                dense
                                                rows="10"
                                                class="json-textarea"
                                                :error="!!defaultPayloadJsonError"
                                                :error-messages="defaultPayloadJsonError"
                                                placeholder='{"campo1": "valor por defecto", "campo2": 0}'
                                                @input="onDefaultPayloadJsonInput"
                                                spellcheck="false"
                                            ></v-textarea>
                                        </div>
                                    </app-col>
                                </app-row>
                            </v-card-text>

                            <v-card-text v-if="vistasTab === 2 && screen_data.entityType && screen_data.entityType.ui_config" class="section-container">
                                <app-row>
                                    <app-col cols="12">
                                        <h3 class="section-title mb-4">
                                            <v-icon left color="primary">mdi-view-list</v-icon>
                                            Vista listado principal
                                        </h3>
                                    </app-col>
                                </app-row>
                                <app-row>
                                    <app-col cols="3">
                                        <v-text-field
                                            v-model="screen_data.entityType.ui_config.icon"
                                            color="primary"
                                            label="Nombre de icono"
                                            outlined
                                            dense
                                            prepend-inner-icon="mdi-emoticon-outline"
                                            :append-icon="screen_data.entityType.ui_config.icon || 'mdi-help'"
                                        />
                                    </app-col>
                                    <app-col cols="3">
                                        <v-select
                                            v-model="screen_data.entityType.ui_config.dialog_size"
                                            :items="dialogSizeOptions"
                                            item-text="text"
                                            item-value="value"
                                            label="Tamaño popup edición"
                                            outlined
                                            dense
                                            prepend-inner-icon="mdi-resize"
                                        />
                                    </app-col>
                                    <app-col cols="6">
                                        <v-autocomplete
                                            label="Campos en cabecera (en orden)"
                                            :items="header_fields_options"
                                            v-model="screen_data.entityType.ui_config.header_fields"
                                            multiple
                                            outlined
                                            dense
                                            chips
                                            small-chips
                                            deletable-chips
                                        ></v-autocomplete>
                                    </app-col>
                                </app-row>

                                <v-divider class="my-6"></v-divider>

                                <VibeComponentGenerator
                                    key="vibe-filter"
                                    title="Filtros"
                                    icon="mdi-filter-variant"
                                    :basePrompt="filterBasePrompt"
                                    v-model="screen_data.entityType.ui_config.filter_template"
                                    :options.sync="screen_data.entityType.ui_config.filter_options"
                                    :previewSchema="filterSchema"
                                    :actionsCatalog="[]"
                                    :companyId="null"
                                />
                                <v-alert type="info" text dense class="mt-4">
                                    <strong>Acción especial:</strong> Usa <code>run_action('refresh_list')</code> para refrescar el listado con los filtros aplicados.
                                </v-alert>
                            </v-card-text>

                            <v-card-text v-if="vistasTab === 3 && screen_data.entityType && screen_data.entityType.ui_config" class="section-container">
                                <app-row>
                                    <app-col cols="12">
                                        <h3 class="section-title mb-4">
                                            <v-icon left color="primary">mdi-table-edit</v-icon>
                                            Componente listado editable
                                        </h3>
                                    </app-col>
                                </app-row>
                                <app-row>
                                    <app-col cols="12">
                                        <v-autocomplete
                                            label="Campos editables"
                                            :items="editable_fields_options"
                                            v-model="screen_data.entityType.ui_config.editable_fields"
                                            multiple
                                            outlined
                                            dense
                                        ></v-autocomplete>
                                    </app-col>
                                </app-row>
                            </v-card-text>

                            <v-card-text v-if="vistasTab === 4 && screen_data.entityType && screen_data.entityType.ui_config" class="section-container">
                                <app-row>
                                    <app-col cols="12">
                                        <h3 class="section-title mb-4">
                                            <v-icon left color="primary">mdi-card-account-details</v-icon>
                                            Pantalla Singleton
                                        </h3>
                                        <v-alert type="info" text dense class="mb-4">
                                            Configura un icono singleton para que este tipo aparezca en el menú lateral con acceso directo a editar una única instancia (sin listado).
                                        </v-alert>
                                    </app-col>
                                </app-row>
                                <app-row>
                                    <app-col cols="4">
                                        <v-text-field
                                            v-model="screen_data.entityType.ui_config.singleton_icon"
                                            color="primary"
                                            label="Icono singleton"
                                            outlined
                                            dense
                                            prepend-inner-icon="mdi-emoticon-outline"
                                            :append-icon="screen_data.entityType.ui_config.singleton_icon || 'mdi-help'"
                                            placeholder="mdi-cog"
                                        />
                                    </app-col>
                                    <app-col cols="4">
                                        <v-select
                                            v-model="screen_data.entityType.ui_config.singleton_mode"
                                            :items="singletonModeOptions"
                                            item-text="text"
                                            item-value="value"
                                            label="Modo singleton"
                                            outlined
                                            dense
                                            prepend-inner-icon="mdi-account-group"
                                            clearable
                                        />
                                    </app-col>
                                    <app-col cols="4" class="d-flex align-center">
                                        <v-checkbox
                                            v-model="screen_data.entityType.ui_config.singleton_get_or_create"
                                            label="Crear instancia automáticamente si no existe"
                                            dense
                                            hide-details
                                        />
                                    </app-col>
                                </app-row>
                            </v-card-text>
                        </v-tab-item>

                        <!-- Tab: Traducciones i18n -->
                        <v-tab-item key="traducciones">
                            <v-card-text v-if="screen_data.entityType && screen_data.entityType.ui_config" class="section-container">
                                <app-row>
                                    <app-col cols="12">
                                        <h3 class="section-title mb-4">
                                            <v-icon left color="primary">mdi-translate</v-icon>
                                            Traducciones (i18n)
                                        </h3>
                                    </app-col>
                                </app-row>
                                <!-- Nombre a mostrar en cada idioma -->
                                <app-row>
                                    <app-col cols="12">
                                        <h4 class="mb-3">Nombre a mostrar (plural)</h4>
                                    </app-col>
                                    <app-col cols="4">
                                        <v-text-field
                                            v-model="screen_data.entityType.ui_config.display_name_cat"
                                            label="Català"
                                            outlined
                                            dense
                                            prepend-inner-icon="mdi-flag"
                                            placeholder="Ej: Factures"
                                        />
                                    </app-col>
                                    <app-col cols="4">
                                        <v-text-field
                                            v-model="screen_data.entityType.ui_config.display_name_es"
                                            label="Español"
                                            outlined
                                            dense
                                            prepend-inner-icon="mdi-flag"
                                            placeholder="Ej: Facturas"
                                        />
                                    </app-col>
                                    <app-col cols="4">
                                        <v-text-field
                                            v-model="screen_data.entityType.ui_config.display_name_en"
                                            label="English"
                                            outlined
                                            dense
                                            prepend-inner-icon="mdi-flag"
                                            placeholder="Eg: Invoices"
                                        />
                                    </app-col>
                                </app-row>

                                <v-divider class="my-4"></v-divider>

                                <!-- Traducciones de campos -->
                                <app-row>
                                    <app-col cols="12">
                                        <h4 class="mb-3">Traducciones de campos</h4>
                                        <v-alert type="info" text dense class="mb-4">
                                            Define traducciones para las keys de los campos en cada idioma (cat, en, es).
                                            Si no hay traducción para un campo, se usará el "title" del esquema.
                                            Las keys pueden incluir campos anidados con notación de punto (ej: "address.city").
                                        </v-alert>
                                    </app-col>
                                </app-row>
                                <app-row>
                                    <app-col cols="12">
                                        <div class="json-editor-container">
                                            <div class="json-editor-toolbar d-flex align-center mb-2">
                                                <v-btn small text color="success" @click="generateTranslationsTemplate" class="mr-2">
                                                    <v-icon small left>mdi-file-document-plus</v-icon>
                                                    Generar plantilla
                                                </v-btn>
                                                <v-btn small text color="primary" @click="formatTranslationsJson" class="mr-2">
                                                    <v-icon small left>mdi-auto-fix</v-icon>
                                                    Formatear
                                                </v-btn>
                                                <v-btn small text color="primary" @click="pasteTranslationsJson" class="mr-2">
                                                    <v-icon small left>mdi-content-paste</v-icon>
                                                    Pegar
                                                </v-btn>
                                                <v-spacer></v-spacer>
                                                <v-chip v-if="translationsJsonError" small color="error" text-color="white">
                                                    <v-icon small left>mdi-alert-circle</v-icon>
                                                    JSON inválido
                                                </v-chip>
                                                <v-chip v-else-if="translationsJsonText" small color="success" text-color="white">
                                                    <v-icon small left>mdi-check-circle</v-icon>
                                                    JSON válido
                                                </v-chip>
                                            </div>
                                            <v-textarea
                                                v-model="translationsJsonText"
                                                outlined
                                                dense
                                                rows="15"
                                                class="json-textarea"
                                                :error="!!translationsJsonError"
                                                :error-messages="translationsJsonError"
                                                :placeholder="translationsPlaceholder"
                                                @input="onTranslationsJsonInput"
                                                spellcheck="false"
                                            ></v-textarea>
                                        </div>
                                    </app-col>
                                </app-row>

                                <v-divider class="my-4"></v-divider>

                                <!-- Traducciones de valores -->
                                <app-row>
                                    <app-col cols="12">
                                        <h4 class="mb-3">Traducciones de valores (listado)</h4>
                                        <v-alert type="info" text dense class="mb-4">
                                            Define traducciones para valores mostrados en el listado.
                                            Cualquier string que coincida con una key se traducirá automáticamente.
                                            Ejemplo: {"es": {"pending": "Pendiente"}, "cat": {"pending": "Pendent"}}
                                        </v-alert>
                                    </app-col>
                                </app-row>
                                <app-row>
                                    <app-col cols="12">
                                        <div class="json-editor-container">
                                            <div class="json-editor-toolbar d-flex align-center mb-2">
                                                <v-btn small text color="primary" @click="formatValueTranslationsJson" class="mr-2">
                                                    <v-icon small left>mdi-auto-fix</v-icon>
                                                    Formatear
                                                </v-btn>
                                                <v-btn small text color="error" @click="clearValueTranslations" class="mr-2">
                                                    <v-icon small left>mdi-delete</v-icon>
                                                    Limpiar
                                                </v-btn>
                                                <v-spacer></v-spacer>
                                                <v-chip v-if="valueTranslationsJsonError" small color="error" text-color="white">
                                                    <v-icon small left>mdi-alert-circle</v-icon>
                                                    JSON inválido
                                                </v-chip>
                                                <v-chip v-else-if="valueTranslationsJsonText" small color="success" text-color="white">
                                                    <v-icon small left>mdi-check-circle</v-icon>
                                                    JSON válido
                                                </v-chip>
                                            </div>
                                            <v-textarea
                                                v-model="valueTranslationsJsonText"
                                                outlined
                                                dense
                                                rows="10"
                                                class="json-textarea"
                                                :error="!!valueTranslationsJsonError"
                                                :error-messages="valueTranslationsJsonError"
                                                :placeholder="valueTranslationsPlaceholder"
                                                @input="onValueTranslationsJsonInput"
                                                spellcheck="false"
                                            ></v-textarea>
                                        </div>
                                    </app-col>
                                </app-row>
                            </v-card-text>
                        </v-tab-item>

                        <!-- Tab: Acciones -->
                        <v-tab-item key="acciones">
                            <v-card-text v-if="screen_data.entityType" class="section-container">
                                <app-row>
                                    <app-col cols="12">
                                        <h3 class="section-title mb-4">
                                            <v-icon left color="primary">mdi-cog-play</v-icon>
                                            Catálogo de acciones
                                        </h3>
                                    </app-col>
                                </app-row>
                                <ActionsCatalogEditor v-model="screen_data.entityType.actions_catalog" />

                                <v-divider class="my-4"></v-divider>

                                <app-row>
                                    <app-col cols="12">
                                        <h3 class="section-title mb-4">
                                            <v-icon left color="primary">mdi-content-save-cog</v-icon>
                                            Opciones de guardado
                                        </h3>
                                    </app-col>
                                </app-row>
                                <app-row>
                                    <app-col cols="3">
                                        <v-checkbox
                                            v-model="screen_data.entityType.ui_config.hide_default_save"
                                            label="Ocultar guardar"
                                            hint="Delega al componente"
                                            persistent-hint
                                        />
                                    </app-col>
                                    <app-col cols="3">
                                        <v-checkbox
                                            v-model="screen_data.entityType.ui_config.hide_default_close"
                                            label="Ocultar cerrar (popup)"
                                            hint="Delega al componente"
                                            persistent-hint
                                        />
                                    </app-col>
                                    <app-col cols="3">
                                        <v-checkbox
                                            v-model="screen_data.entityType.ui_config.hide_default_back"
                                            label="Ocultar volver (página)"
                                            hint="Delega al componente"
                                            persistent-hint
                                        />
                                    </app-col>
                                    <app-col cols="3">
                                        <v-checkbox
                                            v-model="screen_data.entityType.ui_config.hide_create_button"
                                            label="Ocultar botón crear"
                                            hint="Quita el + del listado"
                                            persistent-hint
                                        />
                                    </app-col>
                                </app-row>
                                <app-row>
                                    <app-col cols="3">
                                        <v-checkbox
                                            v-model="screen_data.entityType.ui_config.show_delete_button"
                                            label="Mostrar botón eliminar"
                                            hint="Muestra icono de eliminar en filas"
                                            persistent-hint
                                        />
                                    </app-col>
                                </app-row>
                            </v-card-text>
                        </v-tab-item>

                        <!-- Tab: CRUD Config -->
                        <v-tab-item key="crud_config">
                            <v-card-text v-if="screen_data.entityType" class="section-container">
                                <app-row>
                                    <app-col cols="12">
                                        <h3 class="section-title mb-4">
                                            <v-icon left color="primary">mdi-swap-horizontal</v-icon>
                                            CRUD Slots
                                        </h3>
                                    </app-col>
                                </app-row>
                                <CrudSlotsEditor
                                    v-model="screen_data.entityType.crud_slots"
                                    :workflows="screen_data.available_workflows"
                                />
                            </v-card-text>
                        </v-tab-item>
                    </v-tabs-items>
                </v-card>
            </app-col>

        </app-row>

    </v-container>
    
</template>
  
<script>
import { EntityTypeApiRepository } from "../modules/entities/infra/EntitiesApiRepositories";
import EntitySchemaEditorComponent from "../modules/entities/infra/EntitySchemaEditorComponent";
import { EntityTypeEditorComponent } from "../modules/entities/app/EntityTypeEditorComponent";
import { EntityTypeEditorScreenData } from "../modules/entities/domain/EntityTypeEditorScreenData";
import '../../src/assets/json-schema-editor-vue.css';
import AppRow from "@/components/layout/AppRow.vue";
import AppCol from "@/components/layout/AppCol.vue";
import {mapGetters, mapState} from 'vuex';
import DynamicComponentRenderer from "../modules/entities/infra/DynamicComponentRenderer.vue";
import ActionsCatalogEditor from "@/components/ActionsCatalogEditor.vue";
import CrudSlotsEditor from "@/modules/entities/infra/CrudSlotsEditor.vue";
import VibeComponentGenerator from "@/components/VibeComponentGenerator.vue";

export default {
    name: "EntityTypeEditor",
    components: {
        AppRow,
        AppCol,
        EntitySchemaEditorComponent,
        DynamicComponentRenderer,
        ActionsCatalogEditor,
        CrudSlotsEditor,
        VibeComponentGenerator
    },
    data() {
        const screen_data = new EntityTypeEditorScreenData();
        return {
            screen_data: screen_data,
            entities_editor_component: null,
            test_instance: {},
            currentTab: 0,
            vistasTab: 0,
            schemaEditMode: 'visual',
            schemaJsonText: '',
            jsonError: null,
            translationsJsonText: '',
            translationsJsonError: null,
            defaultPayloadJsonText: '',
            defaultPayloadJsonError: null,
            valueTranslationsJsonText: '',
            valueTranslationsJsonError: null
        };
    },
    props: {
        companydb_id: {
            type: [Number, String],
            required: true,
            default: null
        },
        entity_type_id: {
            type: String,
            required: false,
            default: null
        }
    },
    computed: {
        ...mapState(['search_state', 'tags', 'currentCompany', 'session_information']),
        ...mapGetters({
            userData: 'me/userData',
        }),
        im_staff_or_loginas() {
            return (this.userData && this.userData.is_staff) || (this.session_information && this.userData.username && this.session_information.username != this.userData.username )
        },
        editable_fields_options(){
            let res = []
            if (this.screen_data.entityType && this.screen_data.entityType.schema){
                res = this.screen_data.entityType.schema.required || []
            }
            if (this.screen_data.entityType && this.screen_data.entityType.ui_config && this.screen_data.entityType.ui_config.editable_fields){
                for(let el of this.screen_data.entityType.ui_config.editable_fields ){
                    if (!res.includes(el)){
                        res.push(el)
                    }
                }
            }
            return res
        },
        singletonModeOptions() {
            return [
                { text: 'Por empresa (una instancia por empresa)', value: 'per_company' },
                { text: 'Por usuario (una instancia por usuario)', value: 'per_user' },
                { text: 'Por usuario propietario (sub-usuarios comparten)', value: 'per_owner_user' }
            ];
        },
        dialogSizeOptions() {
            return [
                { text: 'Pequeño (600px)', value: '600' },
                { text: 'Mediano (800px)', value: '800' },
                { text: 'Grande (1000px)', value: '1000' },
                { text: 'Muy grande (1200px)', value: '1200' },
                { text: 'Pantalla completa (90%)', value: '90%' },
                { text: 'Nueva página', value: 'new_page' }
            ];
        },
        header_fields_options(){
            if (this.screen_data.entityType && this.screen_data.entityType.schema && this.screen_data.entityType.schema.properties){
                return this.getNestedFieldOptions(this.screen_data.entityType.schema.properties, '');
            }
            return []
        },
        hasTranslations() {
            return this.screen_data.entityType &&
                   this.screen_data.entityType.ui_config &&
                   this.screen_data.entityType.ui_config.translations &&
                   Object.keys(this.screen_data.entityType.ui_config.translations).length > 0;
        },
        translationsPlaceholder() {
            return `{
  "cat": {
    "field_name": "Nom del camp",
    "nested.field": "Camp anidat"
  },
  "en": {
    "field_name": "Field name",
    "nested.field": "Nested field"
  },
  "es": {
    "field_name": "Nombre del campo",
    "nested.field": "Campo anidado"
  }
}`;
        },
        valueTranslationsPlaceholder() {
            return `{
  "cat": {
    "pending": "Pendent",
    "approved": "Aprovat",
    "rejected": "Rebutjat"
  },
  "en": {
    "pending": "Pending",
    "approved": "Approved",
    "rejected": "Rejected"
  },
  "es": {
    "pending": "Pendiente",
    "approved": "Aprobado",
    "rejected": "Rechazado"
  }
}`;
        },
        editorBasePrompt() {
            if (!this.screen_data.entityType) return '';

            const esquema = this.screen_data.entityType.schema;
            const actions_catalog = this.screen_data.entityType.actions_catalog || [];

            let actions_description = '';
            if (actions_catalog.length > 0) {
                actions_description = '\n\nACCIONES DISPONIBLES:\n';
                actions_description += 'El componente tiene acceso a las siguientes acciones que puede ejecutar mediante run_action(codigo):\n';
                actions_catalog.forEach(action => {
                    actions_description += `- run_action("${action.code}"): ${action.description || 'Sin descripcion'}\n`;
                });
                actions_description += '\nEjemplo de uso: Puedes anadir botones con @click="run_action(\'codigo_accion\')" para ejecutar estas acciones.\n';
            }

            return `Eres un generador de componentes Vue dinamicos. Genera un componente dinamico de Vue 2 usando Vuetify que permita editar un objeto JSON siguiendo este esquema: ${JSON.stringify(esquema, null, 2)}.${actions_description}

El componente debe:
1. Usar v-model con prop "value" y emitir cambios con "input" llamando al metodo update()
2. Estar dentro de un sistema de compilacion dinamica donde:
   - localData se crea automaticamente desde this.value
   - update() y run_action() ya estan definidos
3. Usar componentes de Vuetify (VCard, VTextField, VTextarea, VSelect, VCheckbox, VSwitch, etc.) para cada campo segun su tipo
4. Generar automaticamente los campos del formulario para cada propiedad del objeto y actualizar localData dinamicamente
5. Llamar a this.update() en @input de cada campo para emitir cambios al padre
6. NO incluir boton de guardar
7. El tag principal debe contener un solo elemento raiz
8. Puedes aplicar estilos inline con style="..."
9. Ve al grano, es un componente para modelar payloads, sin titulos ni textos explicativos innecesarios

IMPORTANTE sobre component_options:
- En "data", SOLO incluye datos auxiliares para el componente (contadores, flags, estados UI, etc.)
- NO incluyas una copia de localData en data, ya que localData se crea automaticamente desde this.value
- Usa "computed" para propiedades calculadas basadas en localData o data
- Usa "methods" para funciones auxiliares que no sean update() o run_action() (ya definidos)
- El formato debe ser evaluable como objeto JavaScript literal`;
        },
        createBasePrompt() {
            if (!this.screen_data.entityType) return '';

            const esquema = this.screen_data.entityType.schema;
            const actions_catalog = this.screen_data.entityType.actions_catalog || [];

            let actions_description = '';
            if (actions_catalog.length > 0) {
                actions_description = '\n\nACCIONES DISPONIBLES:\n';
                actions_description += 'El componente tiene acceso a las siguientes acciones que puede ejecutar mediante run_action(codigo):\n';
                actions_catalog.forEach(action => {
                    actions_description += `- run_action("${action.code}"): ${action.description || 'Sin descripcion'}\n`;
                });
                actions_description += '\nEjemplo de uso: Puedes anadir botones con @click="run_action(\'codigo_accion\')" para ejecutar estas acciones.\n';
            }

            return `Eres un generador de componentes Vue dinamicos. Genera un componente dinamico de Vue 2 usando Vuetify para CREAR una nueva instancia de un objeto JSON siguiendo este esquema: ${JSON.stringify(esquema, null, 2)}.${actions_description}

CONTEXTO IMPORTANTE:
- Este formulario es SOLO para CREACION de nuevas instancias
- El usuario empezara con un objeto vacio o con valores por defecto
- Debe ser un formulario limpio, sencillo y enfocado en capturar los datos esenciales
- Considera mostrar solo los campos requeridos o mas importantes inicialmente

El componente debe:
1. Usar v-model con prop "value" y emitir cambios con "input" llamando al metodo update()
2. Estar dentro de un sistema de compilacion dinamica donde:
   - localData se crea automaticamente desde this.value
   - update() y run_action() ya estan definidos
3. Usar componentes de Vuetify (VCard, VTextField, VTextarea, VSelect, VCheckbox, VSwitch, etc.) para cada campo segun su tipo
4. Generar los campos del formulario priorizando los campos requeridos del esquema
5. Llamar a this.update() en @input de cada campo para emitir cambios al padre
6. NO incluir boton de guardar (el sistema lo proporciona)
7. El tag principal debe contener un solo elemento raiz
8. Puedes aplicar estilos inline con style="..."
9. Ve al grano, es un componente para capturar datos nuevos, sin titulos ni textos explicativos innecesarios
10. Considera usar placeholders o hints para guiar al usuario en la creacion

IMPORTANTE sobre component_options:
- En "data", SOLO incluye datos auxiliares para el componente (contadores, flags, estados UI, etc.)
- NO incluyas una copia de localData en data, ya que localData se crea automaticamente desde this.value
- Usa "computed" para propiedades calculadas basadas en localData o data
- Usa "methods" para funciones auxiliares que no sean update() o run_action() (ya definidos)
- El formato debe ser evaluable como objeto JavaScript literal`;
        },
        filterSchema() {
            if (this.screen_data.crudSlotSchemas && this.screen_data.crudSlotSchemas.filter) {
                return this.screen_data.crudSlotSchemas.filter;
            }
            return null;
        },
        filterBasePrompt() {
            if (!this.screen_data.entityType) return '';

            const entitySchema = this.screen_data.entityType.schema;

            return `Eres un generador de componentes Vue dinamicos. Genera un componente dinamico de Vue 2 usando Vuetify que permita configurar filtros para buscar entidades.

SCHEMA DE LA ENTIDAD A FILTRAR:
${JSON.stringify(entitySchema, null, 2)}

SCHEMA DE SALIDA DE FILTROS (crud-slot-filter-params):
${JSON.stringify(this.filterSchema, null, 2)}

El componente debe generar filtros para los campos de la entidad. Los campos disponibles para filtrar son los del schema de la entidad.
Los operadores disponibles estan en el enum del schema de filtros, con sus descripciones en enumDescriptions.

El componente debe:
1. Usar v-model con prop "value" y emitir cambios con "input" llamando al metodo update()
2. localData contendra un objeto con la estructura:
   { filters: [[{match_key, operator, value}, ...], ...] }
   - La lista externa representa grupos OR (al menos uno debe coincidir)
   - Cada lista interna representa condiciones AND (todas deben coincidir dentro del grupo)
   - Ejemplo: [[{match_key: 'status', operator: '==', value: 'active'}], [{match_key: 'status', operator: '==', value: 'pending'}]] = active OR pending
   - Ejemplo: [[{match_key: 'status', operator: '==', value: 'active'}, {match_key: 'category', operator: '==', value: 'A'}]] = active AND category A
3. Usar componentes de Vuetify para crear una interfaz de filtros:
   - VTextField para busquedas de texto
   - VSelect para seleccionar el operador usando las opciones del enum del schema
   - VDatePicker o campos de fecha para rangos de fechas
   - VCheckbox para filtros booleanos
   - VAutocomplete para campos con muchas opciones
   - Botones para anadir/eliminar filtros 
   - Cualquier cosa que se especifique
4. Llamar a this.update() en @input de cada campo para emitir cambios al padre
5. El tag principal debe contener un solo elemento raiz
6. Disenar una interfaz limpia y compacta para filtros segun la especificación del usuario
7. Cada filtro tiene: match_key (campo a filtrar), operator (operador de comparacion), value (valor a comparar)

IMPORTANTE sobre component_options:
- En "data", SOLO incluye datos auxiliares (opciones de selects, estados UI, etc.)
- NO incluyas localData en data
- Usa "computed" para propiedades calculadas
- Usa "methods" para funciones auxiliares si conviene
- El formato debe ser evaluable como objeto JavaScript literal

ACCION ESPECIAL DISPONIBLE:
- run_action('refresh_list'): Refresca el listado aplicando los filtros actuales
- Ejemplo: <v-btn @click="run_action('refresh_list')">Buscar</v-btn>`;
        },
    },
    methods: {
        getNestedFieldOptions(properties, prefix, maxDepth = 3, currentDepth = 0) {
            if (currentDepth >= maxDepth) return [];
            let options = [];
            for (const key of Object.keys(properties)) {
                const fullPath = prefix ? `${prefix}.${key}` : key;
                const prop = properties[key];
                const title = prop.title || key;
                // Add current field
                options.push({
                    text: prefix ? `${fullPath} (${title})` : title,
                    value: fullPath
                });
                // If it's an object with properties, recursively add nested fields
                if (prop.type === 'object' && prop.properties) {
                    const nestedOptions = this.getNestedFieldOptions(prop.properties, fullPath, maxDepth, currentDepth + 1);
                    options = options.concat(nestedOptions);
                }
            }
            return options;
        },
        onSchemaEditModeChange(newMode) {
            if (newMode === 'json') {
                this.schemaJsonText = JSON.stringify(this.screen_data.entityType.schema, null, 2);
                this.jsonError = null;
            }
        },
        async save() {
            await this.entities_editor_component.saveEntityType();
        },
        run_action(act){
            console.log('WE GOT THIS', act)
        },
        onJsonInput() {
            try {
                const parsed = JSON.parse(this.schemaJsonText);
                this.screen_data.entityType.schema = parsed;
                this.jsonError = null;
            } catch (e) {
                this.jsonError = e.message;
            }
        },
        formatJson() {
            try {
                const parsed = JSON.parse(this.schemaJsonText);
                this.schemaJsonText = JSON.stringify(parsed, null, 2);
                this.jsonError = null;
            } catch (e) {
                this.jsonError = e.message;
            }
        },
        async copyJson() {
            try {
                await navigator.clipboard.writeText(this.schemaJsonText);
                this.screen_data.snackbar = {
                    isVisible: true,
                    text: 'JSON copiado al portapapeles',
                    color: 'success',
                    timeout: 2000
                };
            } catch (e) {
                this.screen_data.snackbar = {
                    isVisible: true,
                    text: 'Error al copiar: ' + e.message,
                    color: 'error',
                    timeout: 3000
                };
            }
        },
        async pasteJson() {
            try {
                const text = await navigator.clipboard.readText();
                this.schemaJsonText = text;
                this.onJsonInput();
                if (!this.jsonError) {
                    this.formatJson();
                }
            } catch (e) {
                this.screen_data.snackbar = {
                    isVisible: true,
                    text: 'Error al pegar: ' + e.message,
                    color: 'error',
                    timeout: 3000
                };
            }
        },
        onTranslationsJsonInput() {
            if (!this.translationsJsonText || this.translationsJsonText.trim() === '') {
                this.screen_data.entityType.ui_config.translations = {};
                this.translationsJsonError = null;
                return;
            }
            try {
                const parsed = JSON.parse(this.translationsJsonText);
                this.screen_data.entityType.ui_config.translations = parsed;
                this.translationsJsonError = null;
            } catch (e) {
                this.translationsJsonError = e.message;
            }
        },
        formatTranslationsJson() {
            try {
                const parsed = JSON.parse(this.translationsJsonText);
                this.translationsJsonText = JSON.stringify(parsed, null, 2);
                this.translationsJsonError = null;
            } catch (e) {
                this.translationsJsonError = e.message;
            }
        },
        async pasteTranslationsJson() {
            try {
                const text = await navigator.clipboard.readText();
                this.translationsJsonText = text;
                this.onTranslationsJsonInput();
                if (!this.translationsJsonError) {
                    this.formatTranslationsJson();
                }
            } catch (e) {
                this.screen_data.snackbar = {
                    isVisible: true,
                    text: 'Error al pegar: ' + e.message,
                    color: 'error',
                    timeout: 3000
                };
            }
        },
        initTranslationsJson() {
            if (this.screen_data.entityType && this.screen_data.entityType.ui_config) {
                if (this.screen_data.entityType.ui_config.translations && Object.keys(this.screen_data.entityType.ui_config.translations).length > 0) {
                    this.translationsJsonText = JSON.stringify(this.screen_data.entityType.ui_config.translations, null, 2);
                } else {
                    this.translationsJsonText = '';
                }
            }
        },
        generateTranslationsTemplate() {
            if (!this.screen_data.entityType || !this.screen_data.entityType.schema || !this.screen_data.entityType.schema.properties) {
                this.screen_data.snackbar = {
                    isVisible: true,
                    text: 'No hay esquema definido',
                    color: 'warning',
                    timeout: 3000
                };
                return;
            }
            const fields = this.extractFieldsWithTitles(this.screen_data.entityType.schema.properties, '');
            const template = {
                cat: {},
                en: {},
                es: {}
            };
            for (const field of fields) {
                template.es[field.path] = field.title;
                template.cat[field.path] = '';
                template.en[field.path] = '';
            }
            this.translationsJsonText = JSON.stringify(template, null, 2);
            this.onTranslationsJsonInput();
            this.screen_data.snackbar = {
                isVisible: true,
                text: 'Plantilla generada. Rellena cat y en.',
                color: 'success',
                timeout: 3000
            };
        },
        extractFieldsWithTitles(properties, prefix, maxDepth = 3, currentDepth = 0) {
            if (currentDepth >= maxDepth) return [];
            let fields = [];
            for (const key of Object.keys(properties)) {
                const fullPath = prefix ? `${prefix}.${key}` : key;
                const prop = properties[key];
                const title = prop.title || key;
                fields.push({ path: fullPath, title: title });
                if (prop.type === 'object' && prop.properties) {
                    const nestedFields = this.extractFieldsWithTitles(prop.properties, fullPath, maxDepth, currentDepth + 1);
                    fields = fields.concat(nestedFields);
                }
            }
            return fields;
        },
        // Default Payload methods
        onDefaultPayloadJsonInput() {
            if (!this.defaultPayloadJsonText || this.defaultPayloadJsonText.trim() === '') {
                this.screen_data.entityType.ui_config.create_default_payload = null;
                this.defaultPayloadJsonError = null;
                return;
            }
            try {
                const parsed = JSON.parse(this.defaultPayloadJsonText);
                this.screen_data.entityType.ui_config.create_default_payload = parsed;
                this.defaultPayloadJsonError = null;
            } catch (e) {
                this.defaultPayloadJsonError = e.message;
            }
        },
        formatDefaultPayloadJson() {
            try {
                const parsed = JSON.parse(this.defaultPayloadJsonText);
                this.defaultPayloadJsonText = JSON.stringify(parsed, null, 2);
                this.defaultPayloadJsonError = null;
            } catch (e) {
                this.defaultPayloadJsonError = e.message;
            }
        },
        clearDefaultPayload() {
            this.defaultPayloadJsonText = '';
            this.screen_data.entityType.ui_config.create_default_payload = null;
            this.defaultPayloadJsonError = null;
        },
        generateDefaultPayloadTemplate() {
            if (!this.screen_data.entityType || !this.screen_data.entityType.schema || !this.screen_data.entityType.schema.properties) {
                this.screen_data.snackbar = {
                    isVisible: true,
                    text: 'No hay esquema definido',
                    color: 'warning',
                    timeout: 3000
                };
                return;
            }
            const template = this.generateDefaultValueFromSchema(this.screen_data.entityType.schema);
            this.defaultPayloadJsonText = JSON.stringify(template, null, 2);
            this.onDefaultPayloadJsonInput();
            this.screen_data.snackbar = {
                isVisible: true,
                text: 'Plantilla generada con valores por defecto',
                color: 'success',
                timeout: 3000
            };
        },
        generateDefaultValueFromSchema(schema) {
            if (!schema || !schema.type) return {};
            if (schema.type === 'object' && schema.properties) {
                const obj = {};
                for (const key of Object.keys(schema.properties)) {
                    const prop = schema.properties[key];
                    obj[key] = this.generateDefaultValueForType(prop);
                }
                return obj;
            }
            return {};
        },
        generateDefaultValueForType(prop) {
            if (!prop || !prop.type) return '';
            switch (prop.type) {
                case 'string':
                    return prop.default || '';
                case 'number':
                case 'integer':
                    return prop.default || 0;
                case 'boolean':
                    return prop.default || false;
                case 'array':
                    return prop.default || [];
                case 'object':
                    if (prop.properties) {
                        return this.generateDefaultValueFromSchema(prop);
                    }
                    return prop.default || {};
                default:
                    return '';
            }
        },
        initDefaultPayloadJson() {
            if (this.screen_data.entityType && this.screen_data.entityType.ui_config) {
                if (this.screen_data.entityType.ui_config.create_default_payload && Object.keys(this.screen_data.entityType.ui_config.create_default_payload).length > 0) {
                    this.defaultPayloadJsonText = JSON.stringify(this.screen_data.entityType.ui_config.create_default_payload, null, 2);
                } else {
                    this.defaultPayloadJsonText = '';
                }
            }
        },
        // Value Translations methods
        onValueTranslationsJsonInput() {
            if (!this.valueTranslationsJsonText || this.valueTranslationsJsonText.trim() === '') {
                this.screen_data.entityType.ui_config.value_translations = null;
                this.valueTranslationsJsonError = null;
                return;
            }
            try {
                const parsed = JSON.parse(this.valueTranslationsJsonText);
                this.screen_data.entityType.ui_config.value_translations = parsed;
                this.valueTranslationsJsonError = null;
            } catch (e) {
                this.valueTranslationsJsonError = e.message;
            }
        },
        formatValueTranslationsJson() {
            try {
                const parsed = JSON.parse(this.valueTranslationsJsonText);
                this.valueTranslationsJsonText = JSON.stringify(parsed, null, 2);
                this.valueTranslationsJsonError = null;
            } catch (e) {
                this.valueTranslationsJsonError = e.message;
            }
        },
        clearValueTranslations() {
            this.valueTranslationsJsonText = '';
            this.screen_data.entityType.ui_config.value_translations = null;
            this.valueTranslationsJsonError = null;
        },
        initValueTranslationsJson() {
            if (this.screen_data.entityType && this.screen_data.entityType.ui_config) {
                if (this.screen_data.entityType.ui_config.value_translations && Object.keys(this.screen_data.entityType.ui_config.value_translations).length > 0) {
                    this.valueTranslationsJsonText = JSON.stringify(this.screen_data.entityType.ui_config.value_translations, null, 2);
                } else {
                    this.valueTranslationsJsonText = '';
                }
            }
        }
    },
    watch: {
        'screen_data.entityType': {
            handler(newVal) {
                if (newVal && newVal.ui_config) {
                    this.initTranslationsJson();
                    this.initDefaultPayloadJson();
                    this.initValueTranslationsJson();
                }
            },
            deep: false
        }
    },
    async mounted() {
        this.entities_editor_component = new EntityTypeEditorComponent(new EntityTypeApiRepository(), this.screen_data, this.companydb_id);
        this.entities_editor_component.mountEditor(this.entity_type_id);
    },
  
};
</script>

<style scoped>
.section-container {
    background-color: #fafafa;
    padding: 24px !important;
    margin-bottom: 0;
}

.section-title {
    color: #1976d2;
    font-weight: 500;
    font-size: 1.25rem;
    display: flex;
    align-items: center;
}

.v-divider {
    margin: 0 !important;
}

.advanced-options {
    background-color: white;
    border: 1px solid #e0e0e0;
    border-radius: 4px;
    padding: 16px;
    margin-top: 8px;
}

.advanced-options-title {
    color: #757575;
    font-size: 0.875rem;
    font-weight: 500;
    display: flex;
    align-items: center;
}

.vistas-inner-tabs {
    background-color: #f5f5f5;
    border-bottom: 1px solid #e0e0e0;
}

.schema-mode-toggle {
    border-radius: 4px;
}

.json-editor-container {
    background-color: white;
    border-radius: 4px;
    padding: 12px;
    border: 1px solid #e0e0e0;
}

.json-editor-toolbar {
    border-bottom: 1px solid #e0e0e0;
    padding-bottom: 8px;
}

.json-textarea >>> textarea {
    font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', 'Consolas', monospace !important;
    font-size: 13px !important;
    line-height: 1.5 !important;
    tab-size: 2;
}

.json-textarea >>> .v-input__slot {
    background-color: #f8f8f8 !important;
}
</style>
  